var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.381 0 0 5.381 0 12s5.381 12 12 12 12-5.381 12-12S18.619 0 12 0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.381 0 0 5.381 0 12s5.381 12 12 12 12-5.381 12-12S18.619 0 12 0Z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "non-hover-inner",
    d: "M17.881 9.406v.375c0 3.881-2.962 8.363-8.362 8.363A8.442 8.442 0 0 1 5 16.83c.225.019.469.038.694.038a5.95 5.95 0 0 0 3.656-1.257 2.91 2.91 0 0 1-2.737-2.043 2.725 2.725 0 0 0 1.33-.057 2.919 2.919 0 0 1-2.362-2.868v-.038c.394.225.844.356 1.331.375A2.944 2.944 0 0 1 5.6 8.525c0-.544.15-1.05.394-1.481a8.363 8.363 0 0 0 6.056 3.075 2.665 2.665 0 0 1-.075-.675A2.937 2.937 0 0 1 14.919 6.5c.843 0 1.612.356 2.137.919a5.974 5.974 0 0 0 1.875-.713 3.03 3.03 0 0 1-1.294 1.631 5.63 5.63 0 0 0 1.688-.468 5.373 5.373 0 0 1-1.444 1.537Z",
    fill: "#212A31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "hover-inner",
    d: "M17.881 9.406v.375c0 3.881-2.962 8.363-8.362 8.363A8.442 8.442 0 0 1 5 16.83c.225.019.469.038.694.038a5.95 5.95 0 0 0 3.656-1.257 2.91 2.91 0 0 1-2.737-2.043 2.725 2.725 0 0 0 1.33-.057 2.919 2.919 0 0 1-2.362-2.868v-.038c.394.225.844.356 1.331.375A2.944 2.944 0 0 1 5.6 8.525c0-.544.15-1.05.394-1.481a8.363 8.363 0 0 0 6.056 3.075 2.665 2.665 0 0 1-.075-.675A2.937 2.937 0 0 1 14.919 6.5c.843 0 1.612.356 2.137.919a5.974 5.974 0 0 0 1.875-.713 3.03 3.03 0 0 1-1.294 1.631 5.63 5.63 0 0 0 1.688-.468 5.373 5.373 0 0 1-1.444 1.537Z",
    fill: "#1DA1F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b602a861dccccf7c4e692bbe5956405f.svg";
export { ForwardRef as ReactComponent };